export const FAVOURITED = 'favourite' as const;
export const NAME = 'name' as const;
export const OWNER = 'owner' as const;
export const POPULARITY = 'popularity' as const;

export type SortField = typeof FAVOURITED | typeof NAME | typeof OWNER | typeof POPULARITY;

const sortFields = [NAME, OWNER, POPULARITY, FAVOURITED];

export default sortFields;
